import React, { useEffect, useState } from 'react'

import { Icon, Typography } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'
import CustomSelect from '../../../../../../components/CustomSelect/customSelect'
import { api, request } from '../../../../../../util/handlerRequestUtil'

import './styles.less'

export const AutomaticFilling = ({ fieldProperties, setFieldProperties, selectedFieldId, errors = {} }) => {
  const [show, setShow] = useState(false)
  const [formattedData, setFormattedData] = useState([])
  const [customFields, setCustomFields] = useState([])

  useEffect(() => {
    const { automaticFilling = {} } = fieldProperties
    if (automaticFilling.actionTypeId) {
      listCustomFields(automaticFilling.actionTypeId)
    }
  }, [])

  useEffect(() => {
    listActionTypes()
  }, [])

  async function listActionTypes() {
    try {
      let items = await request(api.listActionTypesDropdown({ active: true }), true)

      setFormattedData(items)
    } catch (error) {
      console.tron.log('error', error)
    }
  }

  async function listCustomFields(id) {
    const { formId } = await request(api.retrieveActionTypes(id), true)
    let items = await request(api.listCustomFields(formId), true)

    items = items.map((item) => ({ value: item.internalFieldName, description: item.fieldName }))
    setCustomFields(items)
  }

  function setActionTypeId(_, value) {
    setFieldProperties({
      property: 'automaticFilling',
      value: { actionTypeId: value, customFieldId: '' },
      fieldId: selectedFieldId
    })
  }

  function setCustomFieldId(field, value) {
    const { automaticFilling = {} } = fieldProperties
    setFieldProperties({
      property: 'automaticFilling',
      value: { ...automaticFilling, [field]: value },
      fieldId: selectedFieldId
    })
  }

  return (
    <div className="automaticFilling">
      <div className="horizontal-line automaticFilling__divider" />

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography className="automaticFilling__title">{getMessage('automaticFilling')}</Typography>
        {show ? (
          <Icon type="minus-square" onClick={() => setShow(false)} className="automaticFilling__plusIcon" />
        ) : (
          <Icon type="plus-square" onClick={() => setShow(true)} className="automaticFilling__plusIcon" />
        )}
      </div>

      {show && (
        <div className="automaticFilling__content">
          <CustomSelect
            field="actionTypeId"
            showSearch
            errors={errors}
            setFieldValue={setActionTypeId}
            rowSpan={25}
            value={fieldProperties.automaticFilling || {}}
            values={formattedData}
            onChange={async (value) => listCustomFields(value)}
          />
          <CustomSelect
            field="customFieldId"
            showSearch
            errors={errors}
            setFieldValue={setCustomFieldId}
            rowSpan={25}
            value={fieldProperties.automaticFilling || {}}
            values={customFields}
          />
        </div>
      )}
    </div>
  )
}
